// компонент, который показывает ограниченный набор значений 10 УС, которые доступны в указанном офисе
import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';
import { SelectInput, MultiSelectInput } from '../forms';
import { promoReferenceActions, PromoReferenceStore } from '../../../promos/store/promoReferenceStore';

type PromoSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    promoReferenceStore?: PromoReferenceStore,
    multiSelect?: boolean,
    excludedValues?: Array<string>,
    addId?: string,
    addName?: string,
    projectId?: string,
  };

const PromoSelector = (props: PromoSelectorProps) => {
  const {
    projectId,
    promoReferenceStore,
    multiSelect,
    excludedValues,
    addName,
    addId,
    ...rest
  } = props;

  const {
    promosForSelector,
    // getPromosForSelectorRequest
  } = promoReferenceStore;

  const toAdd = addId ? [{ id: addId, name: addName }] : [];
  const filteredValues = [...promosForSelector, ...toAdd].filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await promoReferenceActions.getPromoListForSelector(
      {
        showDeleted: false,
        projectId,
      }
    ).finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
        />
      )

  );
};

export default inject('promoReferenceStore')(observer(PromoSelector));
